export const CrescentIcon = () => {
  const radius = 50;
  const innerRadius = radius * 0.6;

  // Add padding to the viewBox
  const padding = 10;
  const viewBoxSize = radius * 2 + padding * 2;

  return (
    <svg width="40" height="40" viewBox={`-${radius + padding} -${radius + padding} ${viewBoxSize} ${viewBoxSize}`}>
      <path
        d={`
          M ${radius} 0
          A ${radius} ${radius} 0 1 1 ${-radius} 0
          A ${innerRadius} ${innerRadius} 0 1 0 ${radius} 0
          Z
        `}
        fill="#fff"
        stroke="#333"
        strokeWidth="2"
      />
    </svg>
  );
};